<script setup lang="ts">
import type { Components } from '@/api/generated/api';
import PerformanceLevelVisualBadge from '@/core/badges/PerformanceLevelVisualBadge.vue';
import OverlappingItemGroup from '@/core/elements/OverlappingItemGroup.vue';

withDefaults(
  defineProps<{
    levels: Components.Schemas.PerformanceLevelV2Dto[];
    layout?: 'inline' | 'overlapping';
    maxVisible?: number;
  }>(),
  {
    layout: 'overlapping',
    maxVisible: 3,
  },
);
</script>

<template>
  <OverlappingItemGroup
    :items="levels"
    :max-visible="maxVisible"
    :get-key="(level) => level.id"
    :overlap="layout === 'inline' ? 'none' : 'xs'"
  >
    <template #item="{ item: level }">
      <PerformanceLevelVisualBadge
        class="!size-icon-md text-sm font-semibold text-tint"
        :performance-level="level"
        :aria-label="level.level.toString()"
        variant="compact"
      />
    </template>

    <template #overflow="{ count }">
      <span
        class="flex size-icon-md shrink-0 items-center justify-center rounded-checkbox border border-divider bg-surface-primary text-sm font-semibold text-secondary"
      >
        +{{ count }}
      </span>
    </template>
  </OverlappingItemGroup>
</template>
